import React from 'react';
import '../app/App.css';
import HomeAssign from '../homeAssign/homeAssign';

class Home extends React.Component {
    constructor(props) {
        super(props);
        console.log(12);
    }
    render() {
        
        return (
            <>
                <HomeAssign></HomeAssign>
            </>
        )
    }
}

export default Home;